import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getIcd10Codes = (state) => allModelsSelector(state, 'Icd10Code');
